import { render, staticRenderFns } from "./GoodsConfigList.vue?vue&type=template&id=508b73c5&scoped=true"
import script from "./GoodsConfigList.vue?vue&type=script&lang=js"
export * from "./GoodsConfigList.vue?vue&type=script&lang=js"
import style0 from "./GoodsConfigList.vue?vue&type=style&index=0&id=508b73c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508b73c5",
  null
  
)

export default component.exports